<template>
  <div class="canvas">
    <div class="biaoti">访客自填表单详情页</div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="访客名字">
        <el-input v-model="searchForm.fangkeName" placeholder="请输入访客名字"></el-input>
      </el-form-item>
      <el-form-item label="访客手机号">
        <el-input v-model="searchForm.fangkePhone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchForm.zhuangtai" placeholder="全部">
          <el-option label="全部" value="全部"></el-option>
          <el-option label="未审批" value="未审批"></el-option>
          <el-option label="审批中" value="审批中"></el-option>
          <el-option label="审批通过" value="审批通过"></el-option>
          <el-option label="审批不通过" value="审批不通过"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="records" style="width: 100%">
      <!-- <el-table-column prop="id" label="编号" width="100"></el-table-column> -->
      <el-table-column prop="fangkeName" label="访客名字" width="180"></el-table-column>
      <el-table-column prop="beifangName" label="接访人名字" width="180"></el-table-column>
      <el-table-column prop="fangkePhone" label="访客手机号" width="180"></el-table-column>
      <el-table-column prop="qiyeName" label="来访单位" width="180"></el-table-column>
      <el-table-column prop="zhuangtai" label="审核状态" width="180"></el-table-column>
      <el-table-column prop="readTime" label="到访时间" width="180"></el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button type="text" @click="viewDetails(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalRecords"
      :page-size="pageSize"
      @current-change="handlePageChange">
    </el-pagination>

    <!-- 审批管理抽屉 -->
    <el-drawer title="审批管理" :visible.sync="drawerVisible" direction="rtl" size="50%">
      <div v-if="!approveDialogVisibleInDrawer">
        <el-form label-width="120px" label-position="left">
          <!-- <el-form-item label="编号" style="padding-left: 20px">
            <el-input v-model="currentRecord.id" disabled></el-input>
          </el-form-item> -->
          <el-form-item label="访客名字" style="padding-left: 20px">
            <el-input v-model="currentRecord.fangkeName" disabled></el-input>
          </el-form-item>
          <el-form-item label="访客手机号" style="padding-left: 20px">
            <el-input v-model="currentRecord.fangkePhone" disabled></el-input>
          </el-form-item>
          <el-form-item label="来访单位" style="padding-left: 20px">
            <el-input v-model="currentRecord.qiyeName" disabled></el-input>
          </el-form-item>
          <el-form-item label="被访名字" style="padding-left: 20px">
            <el-input v-model="currentRecord.beifangName" disabled></el-input>
          </el-form-item>
          <el-form-item label="填写时间" style="padding-left: 20px">
            <el-input v-model="currentRecord.writeTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="到访时间" style="padding-left: 20px">
            <el-input v-model="currentRecord.readTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="到访原因" style="padding-left: 20px">
            <el-input v-model="currentRecord.reason" disabled></el-input>
          </el-form-item>
          <el-form-item label="到访人数" style="padding-left: 20px">
            <el-input v-model="currentRecord.daofangNumber" disabled></el-input>
          </el-form-item>
          <el-form-item label="状态" style="padding-left: 20px">
            <el-input v-model="currentRecord.zhuangtai" disabled></el-input>
          </el-form-item>
          <el-form-item label="访客二维码" style="padding-left: 20px">
            <div class="qr-code">
              <img v-if="currentRecord.qrCode" :src="'data:image/png;base64,' + currentRecord.qrCode">
            </div>
          </el-form-item>
          <el-form-item label="访客数字码" style="padding-left: 20px">
            <el-input v-model="currentRecord.fangkeNumber" disabled></el-input>
          </el-form-item>
          <el-form-item label="不通过原因" style="padding-left: 20px">
            <el-input v-model="currentRecord.errorReason" disabled></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-if="currentRecord.zhuangtai === '未审批' || (currentRecord.zhuangtai === '审批中' && currentRecord.shenpi===2)" @click="approve" class="footer-right">点击进行审批</el-button>
          <el-button @click="drawerVisible = false" class="footer-right">关闭</el-button>
        </span>
      </div>
      <div v-else>
        <el-form>
          <el-form-item>
            <el-button type="primary" @click="approveRecord('通过')" style="margin-left: 20px;">审批通过</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="approveRecord('不通过')" style="margin-left: 20px;">审批不通过</el-button>
          </el-form-item>
          <el-form-item label="不通过原因" style="margin-left: 20px;">
            <el-input v-model="rejectReason" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="approveDialogVisibleInDrawer = false">取消</el-button>
        </span>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        fangkeName: '',
        fangkePhone: '',
        zhuangtai: '全部'
      },
      allRecords: [], // 所有记录
      records: [],    // 当前页展示的记录
      totalRecords: 0,
      pageSize: 10,
      currentPage: 1, // 当前页码（从1开始）
      drawerVisible: false,
      approveDialogVisibleInDrawer: false,
      currentRecord: {},
      rejectReason: ''
    };
  },
  methods: {
    // 查询按钮
    search() {
      this.currentPage = 1;
      this.fetchRecords();
    },

    // 重置表单
    reset() {
      Object.assign(this.searchForm, {
        fangkeName: '',
        fangkePhone: '',
        zhuangtai: '全部'
      });
      this.currentPage = 1;
      this.fetchRecords();
    },

    // 获取数据：一次性拿全量
    fetchRecords() {
      const params = {
        fangkeName: this.searchForm.fangkeName || undefined,
        fangkePhone: this.searchForm.fangkePhone || undefined,
        zhuangtai: this.searchForm.zhuangtai === '全部' ? undefined : this.searchForm.zhuangtai
      };

      Object.keys(params).forEach(key => {
        if (params[key] === undefined) {
          delete params[key];
        }
      });

      this.$axios.get('/api/chaxun_fangke_form_zhuo', { params })
        .then(response => {
          const raw = response.data.data.map(item => {
            if (item.readTime) {
              item.readTime = item.readTime.replace('T', ' ');
            }
            console.log(item)
            return item;
          });
          this.allRecords = raw;
          this.totalRecords = raw.length;
          this.handlePageChange(this.currentPage); // 分页初始化
        })
        .catch(error => {
          console.error('Error fetching records:', error);
        });
    },

    // 分页切片
    handlePageChange(page) {
      this.currentPage = page;
      const start = (page - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.records = this.allRecords.slice(start, end);
    },

    // 查看详情
    viewDetails(row) {
      this.currentRecord = Object.assign({}, row);
      this.drawerVisible = true;
    },

    // 审批按钮点击
    approve() {
      this.approveDialogVisibleInDrawer = true;
    },

    // 审批处理
    approveRecord(status) {
      if (status === '不通过' && !this.rejectReason.trim()) {
        this.$message.error('请输入不通过原因');
        return;
      }

      const approvalData = {
        id: this.currentRecord.id,
        status,
        errorReason: status === '不通过' ? this.rejectReason : '',
        shenpi:this.currentRecord.shenpi
      };

      if (status === '通过') {
        this.$axios.post('/api/fangke_form/change0_zhuo', {
          id: approvalData.id,
          shenpi:this.currentRecord.shenpi
        })
          .then(response => {
            console.log(response)

            this.$message.success("审批通过");
            this.fetchRecords();
          });
      } else {
        this.$axios.post('/api/fangke_form/change1_zhuo', approvalData)
          .then(response => {
            console.log(response)
            this.$message.success("审批不通过");
            this.fetchRecords();
          });
      }

      this.drawerVisible = false;
      this.approveDialogVisibleInDrawer = false;
    }
  },
  mounted() {
    this.fetchRecords();
  }
};
</script>

<style>
.demo-form-inline {
  margin-bottom: 20px;
}
.canvas {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: 97%;
  position: relative;
}
.biaoti {
  font-family: 'Georgia', serif;
  color: #4396e5;
  font-size: 30px;
  font-weight: bold;
  padding: 15px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end; /* 将按钮放置在右边 */
  margin-right: 20px;
}
.footer-right {
  margin-left: 10px; /* 按钮之间的间距 */
}
</style>